import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ROUTE_LIST } from '../../constants/routes';
import { logout } from '../../redux/slices/auth';

export const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
    navigate(ROUTE_LIST.LOGIN);
  }, []);

  return;
};
